import { Component, Input } from '@angular/core';
import { EntityTag } from '@coin/shared/core/util-models';

@Component({
  selector: 'coin-c-position-list-item-tags',
  templateUrl: './position-list-item-tags.component.html',
  styleUrls: ['./position-list-item-tags.component.scss'],
  standalone: false
})
export class PositionListItemTagsComponent {
  @Input() tags?: EntityTag[];
}
